// Gustar, by rule: who likes it (the pronoun) and what is liked (gusta for one
// thing or an action, gustan for more than one).
export type Liker = { a: string; pron: string; en: string; s: boolean };

export const LIKERS: Liker[] = [
  { a: 'A mí', pron: 'me', en: 'I like', s: false },
  { a: 'A ti', pron: 'te', en: 'You like', s: false },
  { a: 'A él', pron: 'le', en: 'He likes', s: true },
  { a: 'A ella', pron: 'le', en: 'She likes', s: true },
  { a: 'A usted', pron: 'le', en: 'You (formal) like', s: false },
  { a: 'A nosotros', pron: 'nos', en: 'We like', s: false },
  { a: 'A vosotros', pron: 'os', en: 'You all like', s: false },
  { a: 'A ellos', pron: 'les', en: 'They like', s: false },
  { a: 'A ustedes', pron: 'les', en: 'You all like', s: false },
  { a: 'A mis padres', pron: 'les', en: 'My parents like', s: false },
  { a: 'A mi hermano', pron: 'le', en: 'My brother likes', s: true },
];

export type Liked = { es: string; en: string; plural: boolean; action?: boolean };

export const LIKED: Liked[] = [
  { es: 'el chocolate', en: 'chocolate', plural: false },
  { es: 'la música', en: 'music', plural: false },
  { es: 'el fútbol', en: 'soccer', plural: false },
  { es: 'la pizza', en: 'pizza', plural: false },
  { es: 'el verano', en: 'summer', plural: false },
  { es: 'la playa', en: 'the beach', plural: false },
  { es: 'el café', en: 'coffee', plural: false },
  { es: 'el español', en: 'Spanish', plural: false },
  { es: 'los perros', en: 'dogs', plural: true },
  { es: 'las películas de terror', en: 'horror movies', plural: true },
  { es: 'los videojuegos', en: 'video games', plural: true },
  { es: 'las fresas', en: 'strawberries', plural: true },
  { es: 'los lunes', en: 'Mondays', plural: true },
  { es: 'las matemáticas', en: 'math', plural: true },
  { es: 'los tacos', en: 'tacos', plural: true },
  { es: 'bailar', en: 'to dance', plural: false, action: true },
  { es: 'leer', en: 'to read', plural: false, action: true },
  { es: 'nadar', en: 'to swim', plural: false, action: true },
  { es: 'cocinar', en: 'to cook', plural: false, action: true },
  { es: 'jugar al fútbol', en: 'to play soccer', plural: false, action: true },
  { es: 'cantar y bailar', en: 'to sing and dance', plural: false, action: true },
];

export const PRONOUNS = ['me', 'te', 'le', 'nos', 'os', 'les'];
